import React, { useState, useEffect } from 'react';
import Widget from "../../../widget/src/enqelt-react-widget/widget-example";
import { 
  Box, 
  Modal, 
  ModalOverlay, 
  ModalContent, 
  ModalHeader, 
  ModalBody, 
  ModalCloseButton,
  Input,
  Button,
  VStack,
  Text
} from "@chakra-ui/react";

export default function WidgetPreview() {
  const [settings, setSettings] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const [showUrlModal, setShowUrlModal] = useState(true);
  const [previewUrl, setPreviewUrl] = useState('https://enqelt.com');
  const [inputUrl, setInputUrl] = useState('');

  useEffect(() => {
    const savedSettings = localStorage.getItem('previewSettings');
    if (savedSettings) {
      try {
        const parsedSettings = JSON.parse(savedSettings);
        setSettings(parsedSettings);
      } catch (error) {
        console.error('Error parsing settings:', error);
      }
    }
  }, []);

  const handleUrlSubmit = (e) => {
    e.preventDefault();
    if (inputUrl) {
      // Add https:// if not present
      const formattedUrl = inputUrl.startsWith('http') ? inputUrl : `https://${inputUrl}`;
      setPreviewUrl(formattedUrl);
    }
    setShowUrlModal(false);
  };

  if (!settings) {
    return null;
  }

  return (
    <>
      <Modal 
        isOpen={showUrlModal} 
        onClose={() => setShowUrlModal(false)}
        closeOnOverlayClick={false}
        closeOnEsc={false}
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Enter Preview Website</ModalHeader>
          <ModalCloseButton />
          <ModalBody pb={6}>
            <VStack spacing={4}>
              <Text>Enter the website URL where you want to preview the widget:</Text>
              <form onSubmit={handleUrlSubmit} style={{ width: '100%' }}>
                <Input
                  placeholder="e.g., example.com"
                  value={inputUrl}
                  onChange={(e) => setInputUrl(e.target.value)}
                  mb={4}
                />
                <Button colorScheme="blue" type="submit" width="100%">
                  Preview Widget
                </Button>
              </form>
            </VStack>
          </ModalBody>
        </ModalContent>
      </Modal>

      <Box
        height="100vh"
        width="100vw"
        position="relative"
        overflow="hidden"
      >
        <Box
          as="iframe"
          src={previewUrl}
          width="100%"
          height="100%"
          border="none"
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0
          }}
        />

        <Box
          position="fixed"
          bottom="20px"
          right="20px"
          zIndex={1000}
          maxWidth="100vw"
          maxHeight="calc(100vh - 40px)"
          pointerEvents="auto"
        >
          <Widget 
            key={JSON.stringify(settings)} 
            settings={settings} 
            isOpen={isOpen}
          />
        </Box>
      </Box>
    </>
  );
}